import { currentOrientation, viewport } from "@gr-exports/async/viewport";
import { on } from "@gr-exports/async/event";
import type { Orientation, OrientationOptions, OrientationUnknown } from "./types";
import { digestMessage } from "../utils/utils";
import type { Viewport } from "../../../exports/viewport";
import type { NexusHandler, NexusSignal } from "../../../exports/nexus";
import type { Unset } from "../../event/head";

export const PORTRAIT = "portrait";
export const LANDSCAPE = "landscape";

export const defaults: OrientationOptions = {
  [PORTRAIT]: window.matchMedia(`(orientation: ${PORTRAIT})`),
  [LANDSCAPE]: window.matchMedia(`(orientation: ${LANDSCAPE})`),
};

/**
 *
 *
 *
 */
export const getListener =
  (co: Orientation, signal: NexusSignal<Orientation | OrientationUnknown | undefined>) =>
  /*                                                         */
  (query: MediaQueryListEvent) => {
    if (query.matches) signal.set(co);
  };

/**
 *
 *
 *
 *
 */
export const initializeOrientationHandler = (
  options = defaults,
  signal: NexusSignal<Orientation | OrientationUnknown | undefined> = currentOrientation,
): Unset[] =>
  Object.entries(options).map(([bp, query]) => on(query, "change", getListener(bp, signal)));

/**
 *
 */
export const getCurrentOrientation = ((options = defaults) =>
  Object.entries(options).find(([, query]) => query.matches)?.[0] ||
  "unknown") satisfies NexusHandler<Viewport["getCurrentOrientation"]>;

/**
 *
 */
export const isActiveOrientation = ((ids = [], options = defaults) =>
  !!ids.find((bp) => options[bp]?.matches)) satisfies NexusHandler<Viewport["isActiveOrientation"]>;

export const withOrientations = (async (options = defaults) => {
  const key = await digestMessage(
    Object.values(options)
      .map(({ media }) => media)
      .join(","),
  );

  const signal = viewport.__orientations[key];
  if (!signal.isReady) signal.assignStore(getCurrentOrientation(options));

  initializeOrientationHandler(options, signal);

  return {
    current: signal,
    isActive: (orientations) => isActiveOrientation(orientations, options),
  };
}) satisfies NexusHandler<Viewport["withOrientations"]>;
